import React, { Component } from 'react';
import { auth, firestore } from './../../firebase-config';
import Cabecalho from './../../componentes/Cabecalho';
import CabecalhoPainel from '../../componentes/CabecalhoPainel';
import { Redirect } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import { ValidatorForm, TextValidator} from 'react-material-ui-form-validator';
import InputMask from 'react-input-mask';
import TextField from '@material-ui/core/TextField';

import './../custom_form.css';

class RevendaUsuariosIncluir extends Component {

    constructor (props){
        super(props);

        this.state = {
            returnPagina: false,
            estaGravando: false,
            nome: "",
            role: "client",
            senha: "",
            confirmasenha: "",
            email: "",
            telefone1: "",
            telefone2: "",
            idRevenda: props.match.params.idRevenda,
            nome_revenda: "",
            usuarioLogado: JSON.parse(window.localStorage.getItem("usuarioLogado")),
        }

        this.mounted = false;

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);

    }

    componentDidMount(){

        this.mounted = true;

        // firestore.settings({ timestampsInSnapshots: true });
        firestore.collection("revenda").doc(this.state.idRevenda)
        .get()
        .then(doc => {
            if (doc.exists) {
                this.setState({
                    nome_revenda: doc.data().penome_fantasia,
                });
            }
        }).catch(function(error) {
        });

    }

    componentWillMount() {
        ValidatorForm.addValidationRule('isPasswordMatch', (value) => {
            if (value !== this.state.senha) {
                return false;
            }
            return true;
        });
    }

    handleChange(event) {

        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name   = target.name;

        this.setState({
            [name]: value
        });
    }

    handleSubmit(event) {

        this.setState({estaGravando: true});

        var user = JSON.parse(window.localStorage.getItem("usuarioLogado"));

        var usuario = {
            nome: this.state.nome,
            role: this.state.role,
            revenda: this.state.idRevenda,
            created_id: user.id,
            updated_id: user.id,
            telefone1: this.state.telefone1,
            telefone2: this.state.telefone2,
        }

        auth.createUserWithEmailAndPassword(this.state.email.toLowerCase(), this.state.senha)
        .then(res => {
            // firestore.settings({ timestampsInSnapshots: true });
            firestore.collection('usuarios').doc(this.state.email.toLowerCase()).set(usuario)
            .then(res => { 
                this.setState({returnPagina: true, estaGravando: false});
            })
            .catch(err => { 
                this.setState({returnPagina: true, estaGravando: false});     
            });
        })
        .catch(error => {

            this.setState({estaGravando: false});

            var errorCode = error.code;
            if (errorCode === 'auth/email-already-in-use') {
                alert('Esta conta de e-mail já está cadastrada no sistema.');
            }else if (errorCode === 'auth/invalid-email') {
                alert('Este endereço de e-mail não é válido.');
            }else if (errorCode === 'auth/weak-password') {
                alert('Esta senha é considerada fraca, tente novamente com uma senha mais segura.');
            } else {
                alert('Erro ao gravar usuário');
            }

        });

        event.preventDefault();

    }

    render(){
        const { 
            estaGravando, 
            nome,
            senha,
            confirmasenha,
            email,
            nome_revenda,
            telefone1,
            telefone2,
            role
        } = this.state;

        if(this.state.returnPagina){
            var link = "/revenda/"+this.state.idRevenda+"/usuarios/listar";
            return <Redirect to={link} />;
        }

        if(this.state.usuarioLogado !== null && this.state.usuarioLogado.role !== 'admin' && this.state.idRevenda !== this.state.usuarioLogado.revenda){
            return <Redirect to='/acesso-negado' />
        }
        
        return (

            <div>
                {
                    this.state.usuarioLogado !== null && this.state.usuarioLogado.role === 'admin' ? <Cabecalho /> :  <CabecalhoPainel />
                } 
                <div id="page-wrapper">
                    <div className="row">
                        <div className="col-lg-12">
                            <h1 className="page-header">Usuários<br/><small>Revenda: { nome_revenda }</small></h1>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="panel panel-default">
                                <div className="panel-heading">
                                    Incluir novo usuário
                                </div>
                                <div className="panel-body">

                                    <ValidatorForm
                                        ref="form"
                                        onSubmit={this.handleSubmit}
                                    >
                                        <div className="row">
                                            <div className="col-lg-5">
                                                <div className="form-group">
                                                    <TextValidator
                                                        label="Nome *"
                                                        onChange={this.handleChange}
                                                        name="nome"
                                                        value={nome}
                                                        className="form-ui-bootstrap"
                                                        validators={['required']}
                                                        errorMessages={['Preenchimento obrigatório']}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-lg-5">
                                                <div className="form-group">
                                                    <TextValidator
                                                        label="E-mail *"
                                                        onChange={this.handleChange}
                                                        name="email"
                                                        value={email}
                                                        className="form-ui-bootstrap"
                                                        validators={['required', 'isEmail']}
                                                        errorMessages={['Preenchimento obrigatório', 'E-mail inválido']}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-lg-2">
                                                <div className="form-group">
                                                    <label>Acesso *</label>
                                                    <select className="form-ui-bootstrap" name="role" onChange={this.handleChange} value={ role }>
                                                        <option value="client">Usuário</option>
                                                        <option value="gestor">Gestor</option>
                                                    </select>                                                
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-lg-6">
                                                <div className="form-group">
                                                    <InputMask
                                                        mask="(99) 99999-9999"
                                                        value={telefone1}
                                                        label="Telefone 1 *"
                                                        name="telefone1"
                                                        onChange={this.handleChange}
                                                    >
                                                        {() => <TextField
                                                        label="Telefone 1 *"
                                                        name="telefone1"
                                                        type="text"
                                                        className="form-ui-bootstrap"
                                                        />}
                                                    </InputMask>
                                                </div>
                                            </div>
                                            <div className="col-lg-6">
                                                <div className="form-group">
                                                    <InputMask
                                                        mask="(99) 99999-9999"
                                                        value={telefone2}
                                                        label="Telefone 2 *"
                                                        name="telefone2"
                                                        onChange={this.handleChange}
                                                    >
                                                        {() => <TextField
                                                        label="Telefone 2 *"
                                                        name="telefone2"
                                                        type="text"
                                                        className="form-ui-bootstrap"
                                                        />}
                                                    </InputMask>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-lg-6">
                                                <div className="form-group">
                                                    <TextValidator
                                                        label="Senha *"
                                                        type="password"
                                                        onChange={this.handleChange}
                                                        name="senha"
                                                        value={senha}
                                                        className="form-ui-bootstrap"
                                                        validators={['required']}
                                                        errorMessages={['Preenchimento obrigatório']}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-lg-6">
                                                <div className="form-group">
                                                    <TextValidator
                                                        label="Confirmação de senha *"
                                                        onChange={this.handleChange}
                                                        type="password"
                                                        name="confirmasenha"
                                                        value={confirmasenha}
                                                        className="form-ui-bootstrap"
                                                        validators={['isPasswordMatch','required']}
                                                        errorMessages={['As senhas não coincidem', 'Preenchimento obrigatório']}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-lg-12">
                                                <Button type="submit" variant="contained" color="primary" disabled={estaGravando} >Gravar</Button>
                                            </div>
                                        </div>
                                    </ValidatorForm>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        )
    }

}

export default RevendaUsuariosIncluir
